module.exports = __webpack_public_path__ + "static/img/腾龙大道2.a390b7dd.png";